import { Model } from '@vuex-orm/core';
import ParticipantModel from './ParticipantModel';
import MatchModel from './MatchModel';
import { v4 as uuid } from 'uuid';
import {utils} from '../services/utils';

export default class PouleModel extends Model {
  static entity = 'poules'

  static fields () {
    return {
      id: this.uid(() => uuid()),
      name: this.string(''),
      order: this.number(0),
      participants: this.hasMany(ParticipantModel, 'poule_id'),
      matches: this.hasMany(MatchModel, 'poule_id'),
      created_at: this.attr(null)
    };
  }

  static beforeCreate(model) {
    model.created_at = utils.nowDateString();
  }

  /**
   * Get full name of the user.
   */
  get find_match () {
    return "sdfsdf"
    // return `${participantId_1} ${participantId_2}`
  }

}
